// https://stackoverflow.com/a/44134328
export const hslToHex = (hsl) => {
  const h = hsl.substring(hsl.indexOf('(') + 1, hsl.indexOf(','));
  const s = hsl.substring(hsl.indexOf(' ') + 1, hsl.indexOf('%'));
  let l = hsl.substring(hsl.lastIndexOf(' ') + 1, hsl.lastIndexOf('%'));
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0'); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};

// https://24ways.org/2010/calculating-color-contrast
export const getTextColorByContrast = (hexcolor, darkColor, brightColor) => {
  if (hexcolor.includes('hsl')) hexcolor = hslToHex(hexcolor);
  hexcolor = hexcolor.replace('#', '');
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? darkColor : brightColor;
};
